import React, { useState,useEffect } from 'react';
import Input from '../../atoms/Input/Input';
import Button from '../../atoms/Button/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import useRequest from "../../../context/useRequest";
import ConfirmationModal from "../../atoms/ConfirmationModal/ConfirmationModal";
const FormNewsletter =()=>{
    const { data: isNewsletterData, sendRequest } = useRequest();
    const [isNewsletter, setIsNewsletter] = useState('');
    const [isFieldErrors, setIsFieldErrors] = useState({})
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
            if (isNewsletterData) {
                setIsNewsletter(isNewsletterData.email);
            }
        }, [isNewsletterData]);
    const emailHandler = (e) => {
        setIsNewsletter(e.target.value);
        setIsFieldErrors((prevErrors) => ({
            ...prevErrors,
            email: "",
        }));
       
    };
    const emailSubmitHandler = async (e) => {
        e.preventDefault()
        const formNewsLetterData = new FormData();
        formNewsLetterData.append("email", isNewsletter);
        try {
            const response = await sendRequest({
                method: "POST",
                url: "/newsLetter",
                body:  formNewsLetterData,
            });

            if (response) {
                setShowModal(true);
                
                // alert("Form submitted successfully!");
            } else {
                console.log("Condition failed. Response or data is missing.");
            }
        } catch (error) {
            console.error("Error response:", error.response);
            if (error.response?.data?.errors) {
                setIsFieldErrors(error.response.data.errors);
            } else {
                alert("An unexpected error occurred.");
            }
        }
    }
    const handleCloseModal = () => {
        setShowModal(false);
        setIsNewsletter("");
    };
    return(
        <> 
            <form className='newsletter-section--from' onSubmit={emailSubmitHandler}>
                <div className='input-group mb-0 me-3' >
                    <Input
                        type="text"
                        name="email"
                        placeholder="Enter Your email address"
                        value={isNewsletter || ""}
                        onChange={emailHandler}
                        
                    />
                    {isFieldErrors.email && (
                        <p className="error-message">{isFieldErrors.email}</p>
                    )}
                </div>
                <div className='newsletter-section--from-button mb-0' >

                    <Button
                        type="submit"
                        label={
                            <>
                              <FontAwesomeIcon icon={faPaperPlane} />
                              
                            </>
                        }
                        className="newsletter-section--from-button-submit"
                        

                    />
                </div>
            </form>
            <ConfirmationModal
                show={showModal}
                onClose={handleCloseModal}
                title="Newsletter Subscribed Successfully"
                body=" You will now receive the latest updates and news directly to your inbox. Thank you for subscribing! "

                className="modalshow"
                actions={[
                    {
                        label: "Submit",
                        onClick: handleCloseModal,
                        className: "btn-custom",
                    },
                ]}
            />
        </>
    )
}
export default FormNewsletter

